var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "done-black-48dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_16",
    "data-name": "Sustracci\\xF3n 16",
    d: "M17097,23764a11,11,0,1,1,7.777-3.225A11.014,11.014,0,0,1,17097,23764Z",
    transform: "translate(-17085 -23741)",
    fill: "#28a745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_226",
    "data-name": "Trazado 226",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadDoc);
export default __webpack_public_path__ + "static/media/loadDoc.951bebda0f81b9971d0d25026467ab5e.svg";
export { ForwardRef as ReactComponent };